module.exports = __webpack_public_path__ + "assets/img/safari-active.d6ee7824.svg";